import { selectors as requestSelectors } from "redux-request-state";

const automationsBase = state => state.marketplace.automation.automations;
export const getAutomations = requestSelectors.getData( automationsBase );
export const isLoadingAutomations = requestSelectors.isLoading( automationsBase );